import React from "react";
import { Link } from "react-router-dom";
import nadhra from "../Media/nadhra.png";
import tarunjit from "../Media/tarunjit.png";
import aliUsman from "../Media/Ali Usman Qasmi.avif";
import silvia from "../Media/silvia.png";
import heroBg from "../Media/header.png";

import Topbar from "./Topbar";
import Footer from "./Footer";
import ArticleProjects from "./ArticleProjects";
import VideoProjects from "./VideoProjects";
import ProjectProjects from "./ProjectProjects";
import SocialFeed from "./SocialFeed";
import TestimonialsCarousel from "./TestimonialsCarousel";

const HERO_BG_URL = heroBg;

const ENDORSEMENTS = [
  {
    img: nadhra,
    name: "Dr. Nadhra Shahbaz Khan",
    role: "Associate Professor, Art & Architectural History, LUMS",
    text: "Anas brings a rare combination of rigorous archival sensibility and genuine aesthetic intelligence to his research. His engagement with South Asian architectural heritage goes well beyond the surface — he asks the questions that matter.",
  },
  {
    img: aliUsman,
    name: "Dr. Ali Usman Qasmi",
    role: "Professor, South Asian History, LUMS",
    text: "Anas has a historian's instinct for the significance of the overlooked. His research into the intersections of religion, material culture, and collective memory in South Asia is both carefully grounded and genuinely original in its framing.",
  },
  {
    img: tarunjit,
    name: "Dr. Tarunjit Butalia",
    role: "Associate Professor, The Ohio State University",
    text: "Anas approaches the study of South Asian religious and cultural sites with both scholarly precision and a storyteller's eye. His interdisciplinary instincts make him an exceptionally versatile researcher and collaborator.",
  },
  {
    img: silvia,
    name: "Dr. Silvia Davoli",
    role: "Research Associate, Oxford University",
    text: "His curatorial research stands out for its sensitivity to material culture and its commitment to preservation as an act of interpretation. Anas understands that heritage work is always also a form of argument.",
  },
];

const SERVICES = [
  {
    num: "01",
    name: "Guided Tours of Lahore",
    desc: "Immersive walking experiences through Lahore's hidden history, culture, and architecture.",
    icon: "bi-geo-alt",
  },
  {
    num: "02",
    name: "Art & Historical Research",
    desc: "In-depth academic research into South Asian art, culture, and heritage studies.",
    icon: "bi-journal-richtext",
  },
  {
    num: "03",
    name: "Heritage & Cultural Consultancy",
    desc: "Strategic advisory on heritage preservation, cultural documentation, and institutional programming across South Asia.",
    icon: "bi-bank",
  },
  {
    num: "04",
    name: "Film Making",
    desc: "Creative production and storytelling via documentary and short-form film.",
    icon: "bi-camera-reels",
  },
];

const SKILLS = ["English", "Urdu", "Persian", "Sanskrit", "Punjabi", "Sindhi"];

export default function LandingPage() {
  return (
    <>
      <Topbar />

      <section
        className="hero hero-bg"
        id="main"
        style={{ backgroundImage: `url(${HERO_BG_URL})` }}
      >
        <div className="shell">
          <div className="hero-role">
            <span>Art Historian</span>
            <span>Heritage Consultant</span>
            <span>Filmmaker</span>
          </div>
          <h1 className="hero-title">
            Muhammad
            <br />
            Anas <span className="accent">Nasir.</span>
          </h1>
          <p className="hero-desc">
            Exploring the intersection of visual culture, historical context,
            and contemporary storytelling through art, research, and film.
          </p>
        </div>
      </section>

      {/* ABOUT */}
      <section className="about" id="about">
        <div className="shell">
          <p className="eyebrow">About</p>

          <div className="about-grid">
            <p className="about-bio">
              I'm a passionate and creatively driven individual with
              interdisciplinary expertise spanning South Asian art,
              architecture, music, and cinema. My work explores the rich
              cultural heritage of the region while actively engaging with
              contemporary forms of expression, allowing me to draw meaningful
              connections between the past and the present. Through a
              combination of in-depth research, visual storytelling, filmmaking,
              and design, I aim to reinterpret traditional aesthetics in ways
              that resonate with modern audiences. Whether collaborating with
              institutions or working independently, I am committed to
              preserving cultural narratives and making them accessible to a
              wider, global audience.
            </p>

            <div className="info-grid">
              <div className="info-cell">
                <h4>Education</h4>
                <p style={{ fontWeight: 600 }}>LUMS</p>
                <p>BA (Hons) Comparative Literature &amp; Creative Arts</p>
                <p>Minor in Art History</p>
                <p className="muted">2021 – 2025</p>
              </div>
              <div className="info-cell">
                <h4>Focus Areas</h4>
                <p>South Asian Art &amp; Architecture</p>
                <p>Heritage Ethnography</p>
                <p>Documentary Filmmaking</p>
                <p>Curatorial Research</p>
                <p>Visual Storytelling</p>
              </div>
              <div className="info-cell full">
                <h4>Professional Affiliations</h4>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(2, 1fr)",
                    gap: "1.5rem 2rem",
                  }}
                >
                  <div>
                    <p>
                      <span style={{ fontWeight: 600 }}>
                        Tourism Development Specialist
                      </span>
                      <br />
                      <span style={{ fontSize: "0.88rem" }}>
                        Tourism, Archeology &amp; Museum Department, Government
                        of Punjab
                      </span>
                    </p>
                    <p>
                      <span style={{ fontWeight: 600 }}>
                        Research Associate
                      </span>
                      <br />
                      <span style={{ fontSize: "0.88rem" }}>
                        MGSHSS, LUMS &amp; Kashi House, CIC, UK
                      </span>
                    </p>
                  </div>
                  <div>
                    <p>
                      <span style={{ fontWeight: 600 }}>
                        Creative Director &amp; Marketing Head
                      </span>
                      <br />
                      <span style={{ fontSize: "0.88rem" }}>
                        Naqshepaa Social Platform
                      </span>
                    </p>
                    <p>
                      <span style={{ fontWeight: 600 }}>
                        Heritage Consultant
                      </span>
                      <br />
                      <span style={{ fontSize: "0.88rem" }}>
                        CultuRise Pvt. Limited
                      </span>
                    </p>
                  </div>
                </div>
              </div>
              <div className="info-cell full">
                <h4>Languages</h4>
                <div className="chip-row">
                  {SKILLS.map((s) => (
                    <span key={s} className="chip">
                      {s}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* PROJECTS */}
      <ProjectProjects />

      {/* ARTICLES */}
      <ArticleProjects />

      {/* VIDEOS */}
      <VideoProjects />

      {/* SERVICES */}
      <section className="services" id="services">
        <div className="shell">
          <div className="section-head">
            <div>
              <p className="eyebrow">What I Offer</p>
              <h2 className="section-title">Services.</h2>
            </div>
            <Link to="/services" className="link-arrow">
              Know more
            </Link>
          </div>

          <div className="services-list" style={{ marginTop: "3rem" }}>
            {SERVICES.map((s) => (
              <div className="service-row" key={s.num}>
                <span className="service-num">{s.num}</span>
                <h3 className="service-name">{s.name}</h3>
                <p className="service-desc">{s.desc}</p>
                <i className={`bi ${s.icon} service-icon`} />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SOCIAL FEED */}
      <SocialFeed />

      {/* ENDORSEMENTS */}
      <section id="endorsements">
        <div className="shell">
          <p className="eyebrow">Endorsements</p>
          <h2 className="section-title" style={{ marginBottom: "3rem" }}>
            What they <em>say</em>.
          </h2>

          <TestimonialsCarousel items={ENDORSEMENTS} />
        </div>
      </section>

      <Footer />
    </>
  );
}
